"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteCaptchaService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var captchaRecaptchaVerifyPath = "captcha/recaptcha/verify";
var verify = function (request) {
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: JSON.stringify(request),
        path: captchaRecaptchaVerifyPath,
    });
};
exports.authSuiteCaptchaService = {
    verify: verify,
};
